import React, { useState, useRef, useEffect } from 'react';
import './productGalleryInfo.scss';
import { Icon, Text, Button, Tooltip, Modal } from '@ui-kit';

import {
  CompatibleWith,
  FilesTypes,
  PriceLine,
  LicenseLine,
  ViewMore,
  PreviewProductImg,
  AvatarLabel,
  Keywords,
} from '@features';
import { SimilarProducts } from '@widgets';
import { 
  BROWSE_URL,
  ADMIN_USER_PROJECTS_URL 
} from '@app/routes';

const Close = '/images/icons/x-gray700.svg';
const Qestion = '/images/icons/help-circle-gray400.svg';
const DownloadIcon = '/images/icons/download-white.svg';

// You cannot use react-redux hooks in this component!!
const ProductInfo = ({
  navigateTo = () => {},
  product = {},
  similarProducts = [],
  showClose = true,
  linkPreview = false,
  isGallery = false,
  isUserAuth = false,
  isSubscriber = false,
  maxWidth = 'auto',
  addToCart = () => {},
  closeInfo = () => {},
  onSelectTag = () => {},
  callback = () => {},
  getFree = ()=>{},
}) => {
  const [showDescription, setShowDescription] = useState(false);
  const href = useRef();

  const {
    id,
    linkId,
    pathToPreview,
    title = '',
    html_description = '',
    compatibility_draw = '',
    illustration_formats = '',
    price,
    key_words,
    inCart,
    isFree,
    user = {},
  } = product;

  const nowPrice = 0; //isFree ? 0 : price;

  useEffect(() => {
    if (inCart) {
      addedCartsStyles();
    }
  }, [product, inCart]);

  const cutDescription = (text) => {
    if (!text || text === "[]") {
      return '';
    }

    const length = 70;
    const label = !showDescription ? 'view more' : 'show less';

    if (text.length > length && !showDescription) {
      return (
        <Text as="h5" className={`info__descr mb-20`}>
          {text.slice(0, length)}
          <ViewMore
            text={label}
            showDots={true}
            onClick={() => setShowDescription((state) => !state)}
          />
        </Text>
      );
    }

    return (
      <Text as="h5" className={`info__descr mb-20`}>
        {text}
        <ViewMore
          text={label}
          showDots={false}
          onClick={() => setShowDescription((state) => !state)}
        />
      </Text>
    );
  };

  const onSelectKeyword = (keyword) => {
    onSelectTag(keyword);
  };

  const renderPreviewImage = () => {
    if (linkPreview) {
      return (
        <a
          className="product__info-link"
          href={`${BROWSE_URL.pathname}/${linkId}-${id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <PreviewProductImg id={id} pathToPreview={pathToPreview} title={title} alt={html_description} />
        </a>
      );
    }

    return <PreviewProductImg id={id} pathToPreview={pathToPreview} title={title} alt={html_description}/>;
  };

  const renderCartButtons = () => {
      return (
        <Button
          size="lg"
          iconLeft={DownloadIcon}
          onClick={getFree}
          className="free__btn cart__icon"
        >
          {isFree ? 'Download for $0' : 'Download'}
        </Button>
      )
  };

  const addedCartsStyles = () => {
    const current = href.current;

    if (current) {
      current.classList.add('product-in-cart__wrapper');
    }
  };

  const notFoundClass = ["similar__not-found"]

  const navigateToProjects = () => {
    if(isUserAuth && isSubscriber) {
      return window.open(ADMIN_USER_PROJECTS_URL.pathname + '?create-new=true', '_blank');
    }

    callback(product)
  }

  const renderSlider = () => {
    if(similarProducts?.length) {
      return (
        <>
          <Text as="h5" className="similar__title">
            You might like these illustrations
          </Text>
          <SimilarProducts items={similarProducts} addToCart={addToCart} />
        </>
      )
    };

    if(!isGallery) {
      return (
        <div className={notFoundClass.join(' ')}>
          <div className="similar__not-found-content">
            <Text as="h5" className="title">
              This illustration is one of a kind
            </Text>
            <Text as="h5">
              If you want a similar one, please change your request. 
              In case you need something unique, our authors are ready 
              to create an illustration for you from scratch.
            </Text>
          </div>
          <Button
            onClick={navigateToProjects}
            theme="link-color"
            className="arrow-right"
            size="lg"
          >
            Order illustrations
          </Button>
        </div>
      )
    }
  }

  return (
    <div>
      <div className="d-flex pr jc-center product__container-info" style={{width: maxWidth}}>
        {showClose && (
          <Icon
            src={Close}
            onClick={() => closeInfo(id)}
            className="close__icon"
          />
        )}
        <div className="product__info-container d-flex">
          {renderPreviewImage()}
          <div className="additional-data d-flex mt-20">
            <AvatarLabel author={user} />

            <Keywords
              keywords={key_words}
              onSelectKeyword={onSelectKeyword}
              length={6}
            />
          </div>
          <div className="additional-data-mobile">
            <AvatarLabel author={user} />
          </div>
        </div>

        <div className="info__description">
          <Text as="h3" className="info__title mb-12">
            {title}
          </Text>

          {cutDescription(html_description)}

          <div className="d-flex editillustration__wrapper mb-20 ai-center">
            <Text
              as="h6"
              className="mr-8 edit-link"
              onClick={() => callback(product)}
            >
              Edit this illustration
            </Text>
            <Tooltip
              content={editIllustrationTooltipe}
              position="top"
              direction="revers"
              ancorPosition="anchor-right-bottom"
            >
              <Icon
                src={Qestion}
                className="question__icon"
                alt="question__icon"
              />
            </Tooltip>

            <Modal 
              content={editIllustrationModal}
            >
              <Icon
                src={Qestion}
                className="question__icon"
                alt="question__icon"
              />
            </Modal>
          </div>
          <LicenseLine position='bottom' ancorPosition='anchor-right-top' />
          <CompatibleWith compatibility_draw={compatibility_draw} />
          <FilesTypes illustrationFormats={illustration_formats} />
          <PriceLine price={nowPrice} currency="$" isFree={isFree} />
          <div className="additional-data-mobile keywords mb-20">
            <Keywords
              keywords={key_words}
              onSelectKeyword={onSelectKeyword}
              length={6}
            />
          </div>
          <div className={" info__btn " + (inCart || isFree ? ' product-in-cart__wrapper ' : '')} ref={href}>
            {renderCartButtons()}
          </div>
        </div>

        <div className="info__description-tablet">
          <div className="description-left">
            <Text as="h3" className="info__title mb-12">
              {title}
            </Text>

            {cutDescription(html_description)}

            <div className="d-flex editillustration__wrapper mb-20 ai-center">
              <Text
                as="h6"
                className="mr-8 edit-link"
                onClick={() => callback(product)}
              >
                Edit this illustration
              </Text>
              <Tooltip
                content={editIllustrationTooltipe}
                position="top"
                direction="revers"
                ancorPosition="anchor-right-bottom"
              >
                <Icon
                  src={Qestion}
                  className="question__icon"
                  alt="question__icon"
                />
              </Tooltip>

              <Modal 
                content={editIllustrationModal}
              >
                <Icon
                  src={Qestion}
                  className="question__icon"
                  alt="question__icon"
                />
              </Modal>
            </div>
            <div className="additional-data-mobile keywords mb-20">
              <Keywords
                keywords={key_words}
                onSelectKeyword={onSelectKeyword}
                length={6}
              />
            </div>
          </div>
          <div className="description-right">
            <LicenseLine position='bottom' ancorPosition='anchor-right-top' />
            <CompatibleWith compatibility_draw={compatibility_draw} />
            <FilesTypes illustrationFormats={illustration_formats} />
            <PriceLine price={nowPrice} currency="$" isFree={isFree} />
            
            <div className={" info__btn " + (inCart || isFree ? ' product-in-cart__wrapper ' : '')} ref={href}>
              {renderCartButtons()}
            </div>
          </div>
        </div>

      </div>
      {renderSlider()}
    </div>
  );
};

const editIllustrationTooltipe = (
  <>
    <Text as="h6" className="tooltipe__title">
      Do you want to change something?
    </Text>

    <Text as="h6" className="tooltipe__subtitle">
      The FlowPik illustrators can edit this <br />
      illustration for you. You only need to create <br />
      a project and describe what you would like to <br />
      change.
    </Text>
  </>
);

const editIllustrationModal = (
  <>
    <Text as="h6" className="modal__title">
      Do you want to change something?
    </Text>

    <Text as="h6" className="modal__subtitle">
      The FlowPik illustrators can edit this
      illustration for you. You only need to create 
      a project and describe what you would like to 
      change.
    </Text>
  </>
);

export default ProductInfo;
